<template>
  <div id="consultation">
    <div class="consultation">
      <!-- <section>
        <input type="text" placeholder="搜索咨询服务" />
        <i class="fa fa-search"></i>
        <i class="el-icon-minus" style="transform: rotate(90deg);"></i>查看所有咨询服务
      </section>-->
      <section>
        <!--  @click="linkTo(item)" -->
        <aside>
          <span v-for="item in navlist" :key="item.id" @click="linkTo(item.id)">{{item.text}}</span>
        </aside>
        <aside>
          <div>
            <span>夏龙通信服务体系</span>
            <span>7*24小时专业服务支持</span>
            <span>智能化监控</span>
            <span>与电信、联通、移动骨干网光纤互联</span>
            <span>通过ISO9001质量管理体系认证</span>
            <span>通过ISO27001信息安全认证</span>
          </div>
        </aside>
      </section>
    </div>
  </div>
</template>

<script>
import { host } from "../../../const";
export default {
  inject: ["reload"],
  data() {
    return {
      navlist: [
        { id: 1, text: "技术支持", title: "技术支持", url: "/consultation" },
        { id: 2, text: "备案服务", title: "备案服务", url: "/consultation" },
        { id: 3, text: "常见问题", title: "常见问题", url: "/consultation" },
        { id: 4, text: "下载指南", title: "下载指南", url: "/consultation" },
      ],
      navshow: false,
    };
  },
  methods: {
    linkTo(id) {
      //点击跳转
      this.$router.push("/consultation");
      document.querySelectorAll("#menu_nav li").forEach((el) => {
        el.style.borderBottom = "0";
      });
      document.querySelector("#menu_nav li:nth-of-type(6)").style.borderBottom =
        "1px solid white";
      localStorage.setItem("consulID", id);
      this.$eventbus.$emit("consulID", id);
      this.$eventbus.$emit("nav_show", false);
      this.reload();
    },
    getconsultationitem() {
      let url = host + "/portal/home/getconsultationitem";
      this.$axios.get(url, { id: "1" }).then((res) => {
        console.log(res.data.data);
      });
    },
  },
  mounted() {
    // this.getconsultationitem();
    this.navshow = false;
    setTimeout(() => {
      this.navshow = true;
    }, 500);
  },
};
</script>
<style scoped lang="less">
@import "../../../assets/css/main.less";
#consultation {
  width: 100%;
  height: 100%;
  //   background: blanchedalmond;
  .column;
  justify-content: center;
  .consultation {
    width: 100%;
    height: 90%;
    // background: goldenrod;
    .column;
    align-items: flex-start;
    align-content: space-around;
    justify-content: space-around;
    color: white;
    // color: black;
    // section:nth-of-type(1) {
    //   width: 30%;
    //   height: 10%;
    //   background: rgba(204, 204, 204, 0.6);
    //   margin-left: 20px;
    //   .row;
    //   justify-content: space-around;
    //   border-radius: 0.3125rem;
    //   padding: 0 0.3125rem;
    //   input {
    //     height: 60%;
    //     border: 0;
    //     background: none;
    //     outline: none;
    //     color: white;
    //   }
    //   input::-webkit-input-placeholder {
    //     color: white;
    //   }
    //   input::-moz-placeholder {
    //     color: white;
    //   }
    //   input::-ms-input-placeholder {
    //     color: white;
    //   }
    // }
    section:nth-of-type(1) {
      width: 100%;
      height: 80%;
      //   background: gray;
      padding-left: 0.625rem;
      .row;
      justify-content: space-around;
      aside:nth-of-type(1) {
        width: 16.2%;
        height: 100%;
        //   background: hotpink;
        border-right: 0.0625rem solid #ccc;
        .column;
        align-items: flex-start;
        justify-content: space-around;
        span {
          width: 45%;
          height: 2.5rem;
          padding-left: 1rem;
          transition: all ease 500ms;
          .row;
          justify-content: flex-start;
        }
        span:hover {
          width: 90%;
          background: bisque;
          color: black;
          border-radius: 3px 0 3px 0;
        }
      }
      aside:nth-of-type(2) {
        width: 80%;
        height: 100%;
        //   background: bisque;
        .row;
        justify-content: flex-start;
        div {
          width: 20rem;
          height: 100%;
          //   background: darkkhaki;
          .column;
          align-items: flex-start;
          justify-content: space-around;
          margin-right: 0.625rem;
        }
      }
    }
  }
}
</style>